import { Box, Button } from "@chakra-ui/react";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";
import { useEffect } from "react";

const hasEventDescription = (kydEvent?: KYDAdminEvent) =>
  Boolean(kydEvent?.description?.trim() || kydEvent?.description_rich);

const LaunchEventButton = ({
  kydEvent,
  onLaunchEvent,
  loading,
}: {
  loading: Record<string, boolean>;
  onLaunchEvent: () => void;
  kydEvent?: KYDAdminEvent;
}) => {
  useEffect(() => {
    if (!kydEvent) {
      console.info(
        "[LaunchEventButton] Hidden: kydEvent is not loaded yet (undefined)."
      );
      return;
    }

    const draftCount =
      kydEvent.ticket_types
        .concat(kydEvent.tiered_ticket_types)
        ?.filter((tt) => tt.status === "DRAFT").length ?? 0;
    const hasDraftTicketTypes = draftCount > 0;
    const hasImage = !!kydEvent.image;
    const notPendingApproval = kydEvent.status !== "PENDING_APPROVAL";
    const hasDescription = hasEventDescription(kydEvent);

    const visible =
      hasDraftTicketTypes && hasImage && notPendingApproval && hasDescription;

    if (!visible) {
      const failed: string[] = [];
      if (!hasDraftTicketTypes) {
        failed.push(
          `no DRAFT ticket types (draftCount=${draftCount}, total ticket_types=${
            kydEvent.ticket_types?.length ?? 0
          })`
        );
      }
      if (!hasImage) failed.push("missing event image (poster)");
      if (!notPendingApproval) failed.push("status is PENDING_APPROVAL");
      if (!hasDescription) failed.push("missing description");

      console.info("[LaunchEventButton] Hidden — reasons:", failed.join("; "), {
        event_id: kydEvent.id,
        status: kydEvent.status,
        draftCount,
        hasImage,
        hasDescription,
      });
    }
  }, [kydEvent]);

  if (!kydEvent) {
    return null;
  }

  const hasDescription = hasEventDescription(kydEvent);

  return kydEvent.ticket_types
    .concat(kydEvent.tiered_ticket_types || [])
    .filter((tt) => tt.status === "DRAFT").length > 0 &&
    kydEvent.image &&
    kydEvent.status !== "PENDING_APPROVAL" &&
    hasDescription ? (
    <Box
      bg="white"
      borderWidth={"1px"}
      borderColor={"gray.100"}
      roundedTop={"lg"}
      p={4}
      w="100%"
      shadow={"lg"}
      bottom={0}
      position={"sticky"}
    >
      <Button
        onClick={() => onLaunchEvent()}
        isDisabled={loading["blocking"]}
        isLoading={loading["blocking"]}
        background="linear-gradient(-45deg, #FFA63D, #FF3D77, #338AFF, #3CF0C5)"
        backgroundSize="600%"
        color="white"
        w="100%"
        h="50px"
        _hover={{ backgroundColor: "none" }}
      >
        {`Launch ${kydEvent.status === "OPEN" ? "Changes" : "Event"} 🚀`}
      </Button>
    </Box>
  ) : null;
};

export default LaunchEventButton;
